export { SearchResults, SearchLoadingSpinner } from "./SearchResults";
export type { SearchResultsFooter } from "./SearchResults";
export * from "./SearchResults.styled";
